<div class="row m-2">
    <ng-template [ngTemplateOutlet]="button" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="button" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="dropdown" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="modal" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="window" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
</div>

<!--Button-->
<ng-template #button let-disabled='disabled'>
    <div class="col-4">
        <button class="k-button" [disabled]="disabled"><span *ngIf="disabled">Disabled</span>Button</button>
    </div>
</ng-template>

<!--Drop down-->
<ng-template #dropdown let-disabled='disabled'>
    <div class="col-4">
        <div ngbDropdown container="body">
            <button class="btn btn-outline-primary k-text-uppercase mr-2 pt-2" id="dropdownAdd" ngbDropdownToggle
                [disabled]="disabled">
                <span *ngIf="disabled">Disabled&nbsp;</span>Dropdown
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownAdd">
                <button class="dropdown-item k-text-uppercase" ngbDropdownItem>
                    <i class="fal fa-user-circle fa-header-nav-icon fa-fw"></i>Item 1
                </button>
                <button class="dropdown-item k-text-uppercase disabled-text" ngbDropdownItem [disabled]="true">
                    <i class="fal fa-question-circle fa-header-nav-icon fa-fw disabled-text"></i>Item 2 (Disabled)
                </button>
                <div class="dropdown-divider"></div>
                <button class="dropdown-item k-text-uppercase" ngbDropdownItem>
                    <i class="fal fa-sign-out-alt fa-header-nav-icon fa-fw"></i>Item 3
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!--Modal-->
<ng-template #modal let-disabled='disabled'>
    <div class="col-4">
        <button class="k-button" (click)="modalOpened = true">Modal</button>
    </div>
</ng-template>

<!--Window-->
<ng-template #window let-disabled='disabled'>
    <div class="col-4">
        <button class="k-button" (click)="windowOpened = true">Window</button>
    </div>
</ng-template>

<!--Modal dialog-->
<kendo-dialog *ngIf="modalOpened" title="Modal Title" (close)="modalOpened = false;" [minWidth]="600" [minHeight]="500">
    <div>
        Modal Content...
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="modalOpened = false;">Cancel</button>
        <button kendoButton (click)="modalOpened = false;" [disabled]="true">Save
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Window-->
<div class="k-overlay" *ngIf="windowOpened"></div>
<kendo-window [width]="1300" [height]="560" *ngIf="windowOpened" (close)="windowOpened = false;" style="position:fixed"
    [top]="60">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">Window Title</h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <div style="min-height:400px">
        Window Content...
    </div>
    <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
        <button kendoButton [primary]="true" type="button" (click)="windowOpened = false;">Close</button>
    </kendo-dialog-actions>
</kendo-window>